import styles from '../../../assets/styles/userPopover';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { authSliceActions } from '../../../redux/slice/authSlice';
import { Divider, MenuItem, MenuList, Popover } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import LockResetIcon from '@mui/icons-material/LockReset';

import CustomTypography from '../../Typography/typography';
import { userSliceActions } from '../../../redux/slice/userSlice';

const UserPopOver = (props: any) => {
  const { anchorEl, onClose, open } = props;
  const classes = styles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChangePasswordButton = () => {
    dispatch(userSliceActions.openChangePasswordPopUp());
    onClose();
  };

  const handleSignOut = () => {
    dispatch(authSliceActions.signout());
    onClose();
    navigate('/');
  };

  return (
    <>
      {' '}
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        onClose={onClose}
        open={open}
        PaperProps={{ sx: { width: 170 } }}
      >
        <MenuList disablePadding className={classes.menulist}>
          <MenuItem
            className={classes.menuItem}
            onClick={handleChangePasswordButton}
          >
            <LockResetIcon fontSize='small' />
            <CustomTypography className={classes.typography}>
              Change Password
            </CustomTypography>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleSignOut} className={classes.menuItem}>
            <LogoutIcon fontSize='small' />
            <CustomTypography className={classes.typography}>
              Sign out
            </CustomTypography>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};

export default UserPopOver;
